import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'

import { push } from 'react-router-redux';

import NetworkHandler from '../net/NetworkHandler'

import StorageHandler from '../storage/StorageHandler';

import * as ACTIONS from '../containers/constants';

import { error ,success } from '../components/Alert/actions';

import {updateUserInformation ,updateInfodexGroups ,updateCryodexGroups ,getAllCryodexes} from '../containers/Home/actions';

const storageHandler = new StorageHandler();

function* getUserGroups(action){

  const Network = new NetworkHandler();
  
    try{
        const response = yield Network.requestCrydexGroupsGet(action.payload);

        if (!(response instanceof Error)) {
            yield put(
              updateCryodexGroups(
                  response
                )
              );
			  
			  localStorage.setItem("cryodexDefaultGroupId",JSON.stringify(response.data[0].Cryodex_Group_ID));
			  
			  var i;
			  
			  var crydNotInGroups = [];
			  
			  for(i=1; i<response.data.length ; i++)
			  {
				 if(response.data[i].cryodexes.length > 0)
				 {
					 var j;
					 
					 for(j=0; j < response.data[i].cryodexes.length; j++)
					 {
						crydNotInGroups.push(response.data[i].cryodexes[j]); 
					 }
					 
				 }
			  }
			  
			  localStorage.setItem("cryodexesNotInDefaultGroup",JSON.stringify(crydNotInGroups));
			  
			 // localStorage.setItem("cryodexGroups",JSON.stringify(response));
          } else {
            yield put(
              error({
                message: `Unable to get user groups. ${response}`,
              })
            );
        }
  
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to load user groups, please try again.${errorMsg}`,
            })
        );
    }
}

function* createUserGroups(action){

  const Network = new NetworkHandler();
  
    try{
        let groups = {
                  Name: action.payload ,
                  Cryodex_ID: storageHandler.getID(),
                  Group_Type: ACTIONS.SPECIFIED_GROUP
        };
        
        const response = yield Network.requestCryodexGroupsCreate(groups);

        if (!(response instanceof Error)) {
            yield put(
              updateCryodexGroups(
                  response
                )
              );
			  window.location.reload();
          } else {
            yield put(
              error({
                message: `Unable to cryodex group. ${response}`,
              })
            );
          }
  
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to cryodex group, please try again.${errorMsg}`,
            })
        );
    }
}

function* mapcryodexRelationship(action){

  
  const Network = new NetworkHandler();
  
    try{
        
        const response = yield Network.requestMapCryodexRelationship(action.payload);

        if (!(response instanceof Error)) {
          yield put(
            updateCryodexGroups(
                response
              )
            );
		  localStorage.setItem('allCryodexGroups', JSON.stringify(response));
           window.location.reload();
          } else {
            yield put(
              error({
                message: `Unable to get all infodex. ${response}`,
              })
            );
        }
        
  
    }catch (errorMsg) {
      yield put(
          error({
            message: `Unable to load infodex groups, please try again.${errorMsg}`,
          })
      );
  }
}

function* deleteCryodexGroupMember(action){
  
  const Network = new NetworkHandler();
  
    try{
        
        const response = yield Network.requestDeleteCryodexGroupMember(action.payload);
        
        if (!(response instanceof Error)) {

          yield put(
            updateCryodexGroups(
                response
              )
            );
			window.location.reload();
          } else {
            yield put(
              error({
                message: `Unable to delete group member. ${response}`,
              })
            );
        }
        
  
    }catch (errorMsg) {
      yield put(
          error({
            message: `Unable to load infodex groups, please try again.${errorMsg}`,
          })
      );
  }
}

function* deleteUserGroups(action){

  const Network = new NetworkHandler();
  
    try{

        const response = yield Network.requestDeleteCryodexGroup(action.payload);
        
        if (!(response instanceof Error)) {
         
          yield put(
            getAllCryodexes(
                response
              )
            );
			 window.location.reload();
          } else {
            yield put(
              error({
                message: `Unable to delete group member. ${response}`,
              })
            );
        }
    }catch (errorMsg) {
      yield put(
          error({
            message: `Unable to load infodex groups, please try again.${errorMsg}`,
          })
      );
  }
}

function* renameUserGroups(action){

  const Network = new NetworkHandler();
  
    try{

        const response = yield Network.requestRenameCryodexGroup(action.payload);
        
        if (!(response instanceof Error)) {
         
          yield put(
            getAllCryodexes(
                response
              )
            );
			 window.location.reload();
          } else {
            yield put(
              error({
                message: `Unable to delete group member. ${response}`,
              })
            );
        }
    }catch (errorMsg) {
      yield put(
          error({
            message: `Unable to load infodex groups, please try again.${errorMsg}`,
          })
      );
  }
}

export default function* usersSagas() {
  yield takeLatest(ACTIONS.CRYODEX_USER_GROUPS_CREATE, createUserGroups); 
  yield takeLatest(ACTIONS.CRYODEX_USER_GROUPS_GET, getUserGroups);
  yield takeLatest(ACTIONS.CRYODEX_CRYODEX_GROUPS_MAP_RELATIONSHIP, mapcryodexRelationship);
  yield takeLatest(ACTIONS.CRYODEX_USER_GROUPS_DELETE, deleteUserGroups); 
  yield takeLatest(ACTIONS.CRYODEX_USER_GROUPS_RENAME, renameUserGroups); 
  yield takeLatest(ACTIONS.CRYODEX_USER_GROUPS_UPDATE,updateCryodexGroups);
  yield takeLatest(ACTIONS.CRYODEX_CRYODEX_GROUPS_MEMBER_DELETE, deleteCryodexGroupMember);
}

